import i18n from '@/i18n'
import AutocompleteComponent from '@/components/commons/autocomplete/AutocompleteComponent.vue'
import {CALIBRATOR_MODELS} from "../../../../../constants/constants";

export default {
    name: 'CalibratorTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        isValidForm: false,
        circuitQuantity: null,
        isNM444Calibrator: false,
        isPanelCalibrator: false,
        setCalibratorValues: false,
        modelItems: [
            {
                _id: CALIBRATOR_MODELS.B,
                name: i18n.t('equipment.editDialog.calibrator.modelNM344')
            },
            {
                _id: CALIBRATOR_MODELS.LH,
                name: i18n.t('equipment.editDialog.calibrator.modelNM444')
            },
            {
                _id: CALIBRATOR_MODELS.P,
                name: i18n.t('equipment.editDialog.calibrator.modelPanel')
            },
            {
                _id: CALIBRATOR_MODELS.TK,
                name: i18n.t('equipment.editDialog.calibrator.modelNM257')
            }
        ],
        modelSelected: CALIBRATOR_MODELS.B
    }),
    computed: {
        // el modelo tk trabaja con un único circuito
        isSingleCircuitModel() {
            return this.modelSelected === CALIBRATOR_MODELS.TK
        },
        minCircuits() {
            return this.isSingleCircuitModel ? 1 : 2
        },
        maxCircuits() {
            return this.isSingleCircuitModel ? 1 : 6
        }
    },
    created () {
    },
    beforeDestroy() {
    },
    mounted () {
        if (this.model.caliper && this.model.caliper.pressure && this.model.caliper.pressure.hardwareNumber) {
            // se habilita el calibrador y se carga la cantidad de circuitos que tenia configurado el equipo
            this.setCalibratorValues = true
            this.circuitQuantity = Object.keys(this.model.caliper.pressure.hardwareNumber).length
            if(this.circuitQuantity>0){
                this.getInitialCalibratorModel()
            }
        } else {
            this.updateForm()
        }
    },
    methods: {

        getInitialCalibratorModel(){
            let firstKey = Object.keys(this.model.caliper.pressure.hardwareNumber)[0].toString();
            let firstType = this.model.caliper.pressure.hardwareNumber[firstKey].type
            this.modelChanged({_id:firstType});
        },

        updateModelValues(newValue, circuitNumber, basicCalibration) {
            //Esta fincion se ejecuta cada vez que se cambia un valor de los textfields.
            //la variable isBasicCalibration verifica si se esta modificando un tesxtfield de la primera columna (high / base) o de la segunda (low).

            let value = typeof newValue === 'number' ? newValue : parseInt(newValue, 10);
            switch(this.modelSelected){
                case CALIBRATOR_MODELS.B:
                case CALIBRATOR_MODELS.TK:
                    this.model.caliper.pressure.hardwareNumber[circuitNumber].base = value;
                    this.setNM344Configuration(circuitNumber)
                break;
                case CALIBRATOR_MODELS.P:
                case CALIBRATOR_MODELS.LH:
                    if(basicCalibration){
                        this.model.caliper.pressure.hardwareNumber[circuitNumber].base = value;
                        this.model.caliper.pressure.hardwareNumber[circuitNumber].high = value;
                    }else{
                        this.model.caliper.pressure.hardwareNumber[circuitNumber].low = value;
                    }
                break;

            }
        },
        updateCalibrationType(newValue){
            // se recorren los circuitos que existen realmente (la cantidad puede estar cambiando)
            for (const circuitNumber of Object.keys(this.model.caliper.pressure.hardwareNumber)) {

                this.model.caliper.pressure.hardwareNumber[circuitNumber].type= newValue._id
                
                let base = this.model.caliper.pressure.hardwareNumber[circuitNumber].base;
                let high = this.model.caliper.pressure.hardwareNumber[circuitNumber].high; 
                switch(newValue._id){
                    case CALIBRATOR_MODELS.P:
                    case CALIBRATOR_MODELS.LH:
                        if(base && base !== high){
                            this.model.caliper.pressure.hardwareNumber[circuitNumber].high = this.model.caliper.pressure.hardwareNumber[circuitNumber].base
                        }
                    break;
                    case CALIBRATOR_MODELS.B:
                    case CALIBRATOR_MODELS.TK:
                        if(this.model.caliper.pressure.hardwareNumber[circuitNumber].base){
                            this.setNM344Configuration(circuitNumber)
                        }
                    break;
              }
            }
        },
        setNM344Configuration(circuitNumber){
            //Si el modelo seleccionado es NM344 solo se guardará el valor de base.

            this.model.caliper.pressure.hardwareNumber[circuitNumber].high = null;
            this.model.caliper.pressure.hardwareNumber[circuitNumber].low = null;
        },
        modelChanged(newValue) {
            this.modelSelected = newValue._id
            switch(newValue._id){
                case CALIBRATOR_MODELS.P:
                    this.isPanelCalibrator = true;
                    this.isNM444Calibrator = false;
                break;
                case CALIBRATOR_MODELS.LH:
                    this.isNM444Calibrator = true;
                    this.isPanelCalibrator = false;
                break;
                case CALIBRATOR_MODELS.B:
                case CALIBRATOR_MODELS.TK:
                    this.isNM444Calibrator = false;
                    this.isPanelCalibrator = false;
                break;
            }
            // ajusto la cantidad de circuitos al rango del modelo elegido
            if (this.isSingleCircuitModel) {
                this.circuitQuantity = 1
            } else if (this.circuitQuantity < 2) {
                this.circuitQuantity = 2
            }
            this.updateCalibrationType(newValue);
        },
        updateForm(){
            if (this.setCalibratorValues) {
                this.circuitQuantity = 2
            } else {
                this.circuitQuantity = 0
                this.model.caliper = null
            }
        }
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.calibratorTabForm) {
                this.$refs.calibratorTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal !== oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Metodo que se encarga de armar el formulario y cargar valores segun la cantidad de circuitos
         * @param {*} circuitNumber
         */
        circuitQuantity(circuitNumber){
            if (circuitNumber && circuitNumber !== "") {
                if (circuitNumber >= this.minCircuits && circuitNumber <= this.maxCircuits) { // 1 para el modelo tk, entre 2 y 6 para el resto
                    // si ya tenia valores cargados
                    if (this.model.caliper && this.model.caliper.pressure && this.model.caliper.pressure.hardwareNumber){
                        const modelCircuits = Object.keys(this.model.caliper.pressure.hardwareNumber).length
                        // si aumento la cantidad de circuitos que tenia el equipo
                        if (circuitNumber >= modelCircuits) {
                            for (let index = 0; index < circuitNumber; index++) { 
                                const element = this.model.caliper.pressure.hardwareNumber[`0${index+1}`]
                                if (!element) {
                                    let actualModel = this.model.caliper.pressure.hardwareNumber[`0${index}`].type ||  CALIBRATOR_MODELS.B;
                                    this.model.caliper.pressure.hardwareNumber[`0${index+1}`] = {
                                        type: actualModel,
                                        low: null,
                                        high: null,
                                        base: null
                                    }
                                   this.modelChanged({_id:actualModel})
                                    // this.modelSelected = CALIBRATOR_MODELS.B
                                } else if (element.type === CALIBRATOR_MODELS.LH) { 
                                    this.isNM444Calibrator = true
                                    this.modelSelected = CALIBRATOR_MODELS.LH
                                }  else if (element.type === CALIBRATOR_MODELS.P) { 
                                    this.isPanelCalibrator = true 
                                    this.modelSelected = CALIBRATOR_MODELS.P
                                }
                            }
                            // si la cantidad de circuitos disminuye
                        } else {
                            for (let i = 0; i < modelCircuits; i++) {
                                if ((i + 1) > circuitNumber) {
                                    delete this.model.caliper.pressure.hardwareNumber[`0${i+1}`]
                                }
                            }
                        }
                        // cargar valores desde cero
                    } else {
                        let hdwNumber = {}
                        for (let index = 0; index < this.circuitQuantity; index++) {
                            // uso interpolación para que los circuitos queden con formato "01", "02",...
                            hdwNumber[`0${index+1}`] = {
                                type: CALIBRATOR_MODELS.B,
                                low: null,
                                high: null,
                                base: null
                            }
                        }
                        this.modelSelected = CALIBRATOR_MODELS.B
                        this.isNM444Calibrator = false;
                        this.isPanelCalibrator = false;
                        this.model.caliper = {
                            pressure: {
                                hardwareNumber: { ...hdwNumber }
                            }
                        }
                    }
                }
            }
        }
    }
}